import { useState } from 'react'
import { Combobox } from './combobox'
import { startcase } from '../utils'
import { FlaskConicalIcon, XIcon } from 'lucide-react'
import { Button } from './button'
import type { HttpHandler } from 'msw'

type Props = {
  scenarios: Record<string, HttpHandler[]>
  defaultOpen?: boolean
}

export function ScenarioDropdown({ scenarios, defaultOpen }: Props) {
  if (Object.keys(scenarios).length === 0) {
    return null
  }

  return <ScenariosDropdownWithData scenarios={scenarios} defaultOpen={defaultOpen} />
}

function ScenariosDropdownWithData({ scenarios, defaultOpen }: Props) {
  const scenarioOptions = [
    { label: 'None (Good State)', value: '' },
    ...Object.keys(scenarios).map(key => ({
      label: startcase(key),
      value: key,
    })),
  ]
  const urlScenario = new URLSearchParams(window.location.search).get('scenario') || ''
  const [selectedScenario, setSelectedScenario] = useState(urlScenario)
  const [isOpen, setIsOpen] = useState(defaultOpen ?? false)

  const onScenarioChange = (newScenario: string | number) => {
    const scenarioStr = String(newScenario)
    setSelectedScenario(scenarioStr)

    const url = new URL(window.location.href)

    if (scenarioStr) {
      url.searchParams.set('scenario', scenarioStr)
    } else {
      url.searchParams.delete('scenario')
    }

    const hasParams = url.searchParams.toString().length > 0
    const newUrl =
      url.origin + url.pathname + (hasParams ? `?${url.searchParams.toString()}` : '') + url.hash

    window.location.href = newUrl
  }

  return (
    <div className='fixed bottom-5 left-5 z-50 flex items-end gap-2 pointer-events-none'>
      <Button
        size='icon'
        className='pointer-events-auto size-8 rounded-full md:size-10'
        onClick={() => setIsOpen(prev => !prev)}
        aria-label='Toggle scenario selector'
      >
        {isOpen ? (
          <XIcon className='size-4 md:size-5' />
        ) : (
          <FlaskConicalIcon className='size-4 md:size-5' />
        )}
      </Button>
      <div
        className={`min-w-[12.5rem] origin-left transition-all duration-200 ease-out ${
          isOpen
            ? 'pointer-events-auto scale-x-100 opacity-100'
            : 'pointer-events-none scale-x-0 opacity-0'
        }`}
      >
        <Combobox
          items={scenarioOptions}
          value={selectedScenario}
          onChange={onScenarioChange}
          placeholder='Select scenario'
          noItemFoundText='Not found'
        />
      </div>
    </div>
  )
}
